import type { TextMessage } from '~/pages/messages/Messages';

export function TextMessageCard({ msg }: { msg: TextMessage }) {
  return (
    <div
      className={`flex flex-col gap-0.5 ${msg.fromSelf ? 'items-end' : 'items-start'}`}
    >
      <div
        className={`max-w-xs px-4 py-2.5 rounded-2xl text-sm ${
          msg.fromSelf
            ? 'bg-prim text-neut-0 rounded-br-sm'
            : 'bg-neut-100 text-neut-prim rounded-bl-sm'
        }`}
      >
        {msg.content}
      </div>
      <span className="text-xs text-neut-400">{msg.timestamp}</span>
    </div>
  );
}
